import React, {Component} from 'react';

import ToggleInput from "../../../../components/ToggleInput/toggleInput";

export default class AuditView extends Component {

    render() {

        let audit = this.props.item;
        if(!audit){return <div />}

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>Motivo de auditoría</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Descripción</label>
                        <p className={"field-p"}>{audit.description}</p>
                    </div>
                    <div className={"col s12 input-field"}>
                        <ToggleInput
                            selected={audit.active}
                            name={'¿Motivo de auditoría activa?'} />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={"btn btn-shell-empty z-depth-0"}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={"btn btn-shell z-depth-0"}
                            onClick={() => this.props.editAction(audit, 'edit')}
                        >Editar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/AuditView.js